// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__ytdBd","fileBtn":"File_fileBtn__3h8Q3","closeBtn":"File_closeBtn__2RrO0","fileSelected":"File_fileSelected___3zCr","disabled":"File_disabled__2oMZY"};